module.exports = __webpack_public_path__ + "img/selected_icon.a71598a.png";